/** Columns shown on Contacts Search (table, CSV, sort). API responses are limited to these. */
export const CONTACTS_SEARCH_COLUMNS = [
  "_id",
  "email",
  "firstName",
  "lastName",
  "name",
  "phoneNumber",
  "numPurchases",
  "amountSpent",
  "lastActive",
  "postalCode",
  "city",
  "state",
  "country",
  "lat",
  "lng",
  "instagram.igUserId",
  "instagram.igUsername",
  "manychat",
  "joinedAt",
  "unsubscribedFromEmails",
  "createdAt",
  "updatedAt",
] as const;

const ROOT_KEYS = [
  "_id",
  "email",
  "firstName",
  "lastName",
  "name",
  "phoneNumber",
  "numPurchases",
  "amountSpent",
  "lastActive",
  "postalCode",
  "city",
  "state",
  "country",
  "lat",
  "lng",
  "manychat",
  "joinedAt",
  "unsubscribedFromEmails",
  "createdAt",
  "updatedAt",
] as const;

const COLUMN_LABELS: Partial<Record<(typeof CONTACTS_SEARCH_COLUMNS)[number], string>> =
  {
    numPurchases: "# Purchases",
    amountSpent: "Amount Spent",
    lastActive: "Last Active",
  };

export function contactsSearchColumnLabel(
  key: string
): string {
  return COLUMN_LABELS[key as keyof typeof COLUMN_LABELS] ?? key;
}

export function pickContactsSearchLeadFields(
  lead: Record<string, unknown>
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const key of ROOT_KEYS) {
    const v = lead[key];
    if (key === "numPurchases" || key === "amountSpent") {
      out[key] =
        typeof v === "number" && Number.isFinite(v) ? v : 0;
      continue;
    }
    if (key === "lastActive") {
      out[key] = v ?? null;
      continue;
    }
    if (v !== undefined) {
      if (key === "manychat" && v != null && typeof v === "object") {
        const m = v as Record<string, unknown>;
        const manychat: Record<string, unknown> = {};
        if ("id" in m && m.id !== undefined) manychat.id = m.id;
        if (Object.keys(manychat).length > 0) out.manychat = manychat;
      } else {
        out[key] = v;
      }
    }
  }
  const ig = lead.instagram;
  if (ig != null && typeof ig === "object") {
    const igObj = ig as Record<string, unknown>;
    const instagram: Record<string, unknown> = {};
    if (igObj.igUserId !== undefined) instagram.igUserId = igObj.igUserId;
    if (igObj.igUsername !== undefined) instagram.igUsername = igObj.igUsername;
    if (Object.keys(instagram).length > 0) out.instagram = instagram;
  }
  return out;
}
